import { ReferralParams, ReferralParamsKey } from '../hooks/useReferralParams';
import { SessionStorageKey } from '../hooks/useSessionStorage';
import { logger } from '../logger';

export const getReferralParams = (): ReferralParams => {
  try {
    const storedValue = window.sessionStorage.getItem(SessionStorageKey.CAMPAIGN_SOURCE);
    if (!storedValue) {
      return {};
    }
    return JSON.parse(storedValue);
  } catch (error) {
    logger.error('Failed to retrieve referral parameters:', error);
    return {};
  }
};

export const hasReferralParam = (key: keyof typeof ReferralParamsKey | string): boolean => {
  const params = getReferralParams();
  return !!params[key];
};

export const getReferralParam = (key: keyof typeof ReferralParamsKey | string): string | undefined => {
  const params = getReferralParams();
  return params[key];
};

export const getReferralParamsAsQueryString = (): string => {
  const params = getReferralParams();
  const queryParams = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value) {
      queryParams.append(key, value);
    }
  });

  return queryParams.toString();
};

export const clearReferralParams = (specificKeys?: (keyof typeof ReferralParamsKey | string)[]): void => {
  try {
    if (!specificKeys || specificKeys.length === 0) {
      window.sessionStorage.removeItem(SessionStorageKey.CAMPAIGN_SOURCE);
      return;
    }

    const params = getReferralParams();
    let hasChanges = false;

    specificKeys.forEach((key) => {
      if (params[key]) {
        delete params[key];
        hasChanges = true;
      }
    });

    if (hasChanges) {
      window.sessionStorage.setItem(SessionStorageKey.CAMPAIGN_SOURCE, JSON.stringify(params));
    }
  } catch (error) {
    logger.error('Failed to clear referral parameters:', error);
  }
};
